module.exports = __webpack_public_path__ + "static/kansas-city-6d6fdb549948900bf64c9b4cf73e7b5d.png";